<template>
  <div class="test">
    <div
      @mousedown ="mousedownHandler"
      @mousemove ="mousemoveHandler"
      @mouseup   ="mouseupHandler"
      class      ="canvas-surface"
      :style     ="styleObject"
      :class     ="[ canvasActive ? '' : 'canvas-disable' ]"
    >
    </div>
    <canvas-layer
      v-for   ="(layer, index) in layers"
      :ref    ="layer"
      :key    ="index"
      :width  ="width"
      :height ="height"
    />
  </div>
</template>

<script>
import CanvasLayer    from './CanvasLayer'
import { mapGetters } from 'vuex'

export default {
  name: 'CanvasBoard',
  data () {
    return {
      drawing   : false,
      layers    : ['canvas1', 'canvas2'],
      width     : 4000,
      height    : 3000,
      drawStart : {x: 0, y: 0},
      before    : {x: 0, y: 0}
    }
  },
  computed: {
    styleObject () {
      return {
        width  : this.width + 'px',
        height : this.height + 'px'
      }
    },
    ...mapGetters('canvas', ['canvasActive', 'penProperty'])
  },
  mounted () {
    this.$eventHub.$on('canvas-clear', this.ui_clearHandler)
  },
  components: {
    CanvasLayer
  },
  methods: {
    // <--- mouse action
    mousedownHandler (e) {
      this.drawing = true
      this.drawStart = { x: e.clientX, y: e.clientY }
      this.before = { x: e.offsetX, y: e.offsetY }
    },
    mousemoveHandler (e) {
      if (e.buttons === 1 && this.drawing) {
        this.sendDrawAct(e, 'line')
        this.before = { x: e.offsetX, y: e.offsetY }
      }
    },
    mouseupHandler (e) {
      if (
        this.drawStart.x === e.clientX &&
        this.drawStart.y === e.clientY
      ) { this.sendDrawAct(e, 'spot') }
      this.drawing = false
    },
    // mouse action --->
    // <---ui event
    ui_toggleHandler () {
      this.canvasActive = !this.canvasActive
    },
    ui_clearHandler () {
      this.$refs.canvas1[0].clear()
      this.$sockets.of('/canvas').emit('canvasClear')
    },
    // ui event --->
    sendDrawAct (e, type) {
      const data = {
        type            : type,
        beginX          : this.before.x,
        beginY          : this.before.y,
        closeX          : e.offsetX,
        closeY          : e.offsetY,
        contextProperty : this.penProperty
      }
      this.$refs.canvas1[0].draw(data)
      this.$sockets.of('/canvas').emit('canvasDraw', data)
    }
  },
  sockets: {
    canvas: {
      connect () {
        console.log('socket - canvas socket connected')
      },
      joinRoom (data) {
        console.log('socket - canvas socket join room')
        console.log(data)
      },
      canvasDraw (data) {
        this.$refs.canvas1[0].draw(data)
      },
      canvasClear () {
        this.$refs.canvas1[0].clear()
      }
    }
  }
}
</script>

<style scoped>
.canvas-surface {
  position : absolute;
  top      : 0;
  left     : 0;
  z-index  : 200;
  width    : 100%;
  height   : 100%;
}
.canvas-disable {
  pointer-events : none;
}
</style>



// WEBPACK FOOTER //
// src/components/canvas/content/index.vue